import React from 'react'
import { isMobile } from 'react-device-detect'
import { useParams } from 'react-router-dom'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import {
  printInvoicesDarazFromDispatch,
  printShippingLabels,
} from 'client/utils/api-routes-orders'
import FilterLinesIcon from 'client/utils/icons/filter-lines-icon'
import ScanIcon from 'client/utils/icons/scan-icon'
import UploadIcon from 'client/utils/icons/upload-icon'
import { OrdersContext } from 'contexts/OrdersContext'
import {
  $DCprimaryColor,
  DcBreadcrumbs,
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcTag,
  PixelDropDownMenu,
  PixelFactoryContext,
  PixelPageContainer,
  PixelText,
  Section,
  SectionActions,
  SectionContent,
  DcOverlaySlider,
  colors,
  DcText,
} from 'pixel-base'
import DcScanner from 'pixel-base/components/dc-scanner'
import { AjaxResponse } from 'rxjs/ajax'
import { env } from 'shared/env'
import styled from 'styled-components'

import {
  downLoadDispatches,
  downLoadFile,
  get,
  post,
  put,
} from 'utils/api-routes.util'

import DispatchDetailsTable from './components/DispatchDetailsTable'
import DispatchItemDetails from './components/DispatchItemDetails'
import UploadDispatch from './components/UploadDispatch'
import SummaryCard from './SummaryCard'
import { IPixelFactory, Courier } from '../../../../decl.d'

const breadcrumbs = [
  {
    name: 'Orders',
    active: false,
    link: '/orders',
  },
  {
    name: 'Order Dispatches',
    active: false,
    link: '/orders/courier-load-sheet',
  },
  {
    name: 'Details',
    active: true,
  },
]

interface IDispatchDetails {
  cod: string
  packages: number
  dispatch_status: string
  courier_id: number
  courier_name: string
  courier_logo: string
  created_at: string
  created_by_id: number
  created_by_name: string
  dispatch_courier_reference: null
  dispatch_id: number
  dispatch_name: string
  total_cod_amount: number
  total_packages: number
  total_packages_weight: number
  total_pieces: number
  total_skus: number
  warehouse_id: number
  warehouse_name: string
  packed_count: number
  processing_time_stats?: {
    green: number
    yellow: number
    red: number
  }
}
interface IOrders {
  is_packed: boolean
}
const DispatchDetail = () => {
  const [toggleCleared, setToggleCleared] = React.useState(false)
  const [bulkButtonAble, setBulkButtonAble] = React.useState(0)
  const [isPacked, setIsPacked] = React.useState<boolean | null>(null)
  const params = useParams()
  const [filterText, setFilterText] = React.useState('')

  const dispatchID = params.id
  const { state } = React.useContext(OrdersContext)
  const {
    showFailure,
    showSuccess,
    pixelConfirm,
    hidePageLoader,
    showPageLoader,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const [courierList, setCourierList] = React.useState<Courier[]>([])
  const [dispatchTableData, setDispatchTableData] = React.useState([])
  const [selectedOrders, setSelectedOrders] = React.useState([])
  const [tableLoading] = React.useState(false)
  const [showUploadModal, setShowUploadModal] = React.useState(false)
  const [showActions, setShowActions] = React.useState(false)
  const [showScanner, setShowScanner] = React.useState(false)
  const [scannedTrackingId, setScannedTrackingId] = React.useState('')
  const scannerRef = React.useRef<HTMLVideoElement>(null)
  const [bulkDispatchIds, setBulkDispatchIds] = React.useState({
    order_ids: [],
  })
  const [selectedItem, setSelectedItem] = React.useState(null)
  const [isScanning, setIsScanning] = React.useState(false)
  const trackingInputRef = React.useRef<HTMLInputElement>(null)
  const scanTimeoutRef = React.useRef<NodeJS.Timeout | null>(null)
  const triggerFocus = () => {
    if (trackingInputRef.current) {
      trackingInputRef.current.focus()
    }
  }
  const onDispatchItemDetailsClose = () => {
    setSelectedItem(null)
    setScannedTrackingId('')
    triggerFocus()
  }
  React.useEffect(() => {
    setCourierList(state?.couriers)
  }, [state])
  const isDaraz = () => {
    const DarazCouriers = courierList?.filter(
      (cor) => cor?.courier_company === 'Daraz',
    )
    const isDaraz = DarazCouriers?.find(
      (cor) => cor?.courier_id === dispatchDetail?.courier_id,
    )
    return isDaraz ? false : true
  }

  const [dispatchStatus, setDispatchStatus] = React.useState({
    status: '',
  })
  const [dispatchAttachment, setDispatchAttachment] = React.useState({
    attachment_id: '',
    attachment_name: '',
    attachment_path: '',
  })
  const [dispatchDetail, setDispatchDetail] = React.useState<IDispatchDetails>({
    dispatch_status: '',
    dispatch_name: '',
    courier_id: 0,
    courier_name: '',
    courier_logo: '',
    created_at: '',
    created_by_id: 0,
    created_by_name: '',
    dispatch_courier_reference: null,
    dispatch_id: 0,
    total_cod_amount: 0,
    total_packages: 0,
    total_packages_weight: 0,
    total_pieces: 0,
    total_skus: 0,
    warehouse_id: 0,
    warehouse_name: '',
    packed_count: 0,
  })
  const bulkActions = (action) => {
    pixelConfirm({
      title: 'Confirmation',
      message: `${
        action === 'remove-items'
          ? 'Are you sure? you want to Remove this, This action cannot be undone.'
          : 'You are going to mark this order as packed?'
      }`,
      onConfirm: () => {
        showPageLoader()
        post(
          `/dispatch/${dispatchID}/bulk/${action}`,
          bulkDispatchIds,
        ).subscribe((res: any) => {
          if (res.response.data) {
            if (action === 'remove-items') {
              showSuccess('Orders Remove Successfully')
            } else if (action === 'packing-done') {
              showSuccess('Orders Packed Successfully')
            }
            setBulkButtonAble(0)
            setToggleCleared(true)
            const headerDetail = res.response.data.header
            setDispatchDetail({
              ...headerDetail,
              cod: headerDetail?.total_cod_amount?.toString() || '0',
              packages: headerDetail?.total_packages || 0,
              processing_time_stats: headerDetail?.processing_time_stats || {
                green: 0,
                yellow: 0,
                red: 0,
              },
            })
            const tableData = res.response.data.details
            setDispatchTableData(tableData)
            setBulkDispatchIds({
              order_ids: [],
            })
          } else {
            showFailure(res.response.error)
          }
          hidePageLoader()
        })
      },
    })
  }
  const readData = (isPacked: boolean | null) => {
    showPageLoader()
    get(
      `/courier/loadsheet/dispatch/${dispatchID}`,
      isPacked !== null ? { is_packed: isPacked } : {},
    ).subscribe((res: any) => {
      hidePageLoader()
      const headerDetail = res.response.data.header
      setDispatchDetail({
        ...headerDetail,
        cod: headerDetail?.total_cod_amount?.toString() || '0',
        packages: headerDetail?.total_packages || 0,
        processing_time_stats: headerDetail?.processing_time_stats || {
          green: 0,
          yellow: 0,
          red: 0,
        },
      })
      setDispatchStatus(headerDetail?.dispatch_status)
      const tableData = res.response.data.details
      setDispatchTableData(tableData)
      const attachmentDetail = res.response.data.attachment
      if (attachmentDetail && Object.keys(attachmentDetail).length !== 0) {
        setDispatchAttachment(attachmentDetail)
      }
    })
  }
  React.useEffect(() => {
    readData(isPacked)
  }, [isPacked])
  // Auto-focus the tracking input field when component mounts
  React.useEffect(() => {
    if (trackingInputRef.current) {
      trackingInputRef.current.focus()
    }

    // Cleanup function to clear timeout
    return () => {
      if (scanTimeoutRef.current) {
        clearTimeout(scanTimeoutRef.current)
      }
    }
  }, [])
  const refreshDispatchDetail = () => {
    showPageLoader()
    get(`/dispatch/${dispatchID}/refresh`).subscribe((res: any) => {
      hidePageLoader()
      if (res.response.data) {
        const headerDetail = res.response.data.header
        setDispatchDetail({
          ...headerDetail,
          cod: headerDetail?.total_cod_amount?.toString() || '0',
          packages: headerDetail?.total_packages || 0,
          processing_time_stats: headerDetail?.processing_time_stats || {
            green: 0,
            yellow: 0,
            red: 0,
          },
        })
        const tableData = res.response.data.details
        setDispatchTableData(tableData)
      } else {
        showFailure(res.response.error)
      }
    })
  }

  const updateData = () => {
    pixelConfirm({
      title: 'Confirmation',
      message: `Do you want to change status from ${dispatchDetail?.dispatch_status} to ${dispatchStatus?.status}`,
      onConfirm: () => {
        showPageLoader()
        put(`/dispatch/${dispatchID}/status`, dispatchStatus).subscribe(
          (res: any) => {
            hidePageLoader()
            if (res.response.success === true) {
              showSuccess(res.response.message)
              readData(null)
            } else {
              showFailure(res.response.error || res.response.message)
            }
          },
        )
      },
    })
  }
  React.useEffect(() => {
    if (dispatchStatus?.status?.length > 0) {
      updateData()
    }
  }, [dispatchStatus])

  const baseURL = env.SERVER_ADDR
  const { token } = JSON.parse(
    localStorage.getItem('user_info') || '{token: null}',
  )
  const exportReport = () => {
    downLoadDispatches('courier/dispatch/', dispatchID)
  }
  const bulkInvoiceDaraz = () => {
    showPageLoader()
    printInvoicesDarazFromDispatch(dispatchID).subscribe(
      (res: AjaxResponse<any>) => {
        hidePageLoader()
        if (res.response) {
          const html = res.response
          const newWindow = window.open()
          newWindow.document.write(html)
          newWindow.document.close()
        } else {
          showFailure('No Data found')
        }
      },
    )
  }
  const PrintSheetsOptions = [
    {
      label: 'Refresh',
      children: [
        {
          label: 'Refresh Screen',
          clickHandler: () => {
            window.location.reload()
          },
        },
        {
          label: 'Refresh Detail',
          clickHandler: () => {
            refreshDispatchDetail()
          },
        },
      ],
    },
    {
      label: 'Status',
      children: [
        {
          label: 'Open',
          disabled: dispatchDetail.dispatch_status === 'open',
          clickHandler: () => {
            setDispatchStatus({
              status: 'open',
            })
          },
        },
        {
          label: 'Packaging',
          disabled: dispatchDetail.dispatch_status === 'packaging',
          clickHandler: () => {
            setDispatchStatus({
              status: 'packaging',
            })
          },
        },
        {
          label: 'Ready to Ship',
          disabled: dispatchDetail.dispatch_status === 'ready-to-ship',
          clickHandler: () => {
            setDispatchStatus({
              status: 'ready-to-ship',
            })
          },
        },
        {
          label: 'Shipped',
          disabled: dispatchDetail.dispatch_status === 'shipped',
          clickHandler: () => {
            setDispatchStatus({
              status: 'shipped',
            })
          },
        },
      ],
    },
    {
      label: 'Print',
      children: [
        {
          label: 'Load Sheet',
          clickHandler: () => {
            window.open(
              `${baseURL}api/v2/print/dispatch/loadsheet/${token}/${dispatchID}`,
            )
          },
        },
        {
          label: 'Shipping Labels',
          clickHandler: () => {
            window.open(
              `${baseURL}api/v2/print/dispatch/labels/new/${token}/${dispatchID}`,
            )
          },
        },
        {
          label: 'Invoices',
          clickHandler: () => {
            window.open(
              `${baseURL}api/v2/print/dispatch/invoices/new/${token}/${dispatchID}`,
            )
          },
        },
        {
          label: 'Invoices (Daraz)',
          disabled: isDaraz(),
          clickHandler: () => {
            bulkInvoiceDaraz()
          },
        },
        {
          label: 'Invoices & Labels Together',
          clickHandler: () => {
            window.open(
              `${baseURL}api/v2/print/dispatch/invoices-and-labels/new/${token}/${dispatchID}`,
            )
          },
        },
        {
          label: 'Money Order',
          clickHandler: () => {
            window.open(
              `${baseURL}api/v2/print/dispatch/money-order/${token}/${dispatchID}`,
            )
          },
        },
        {
          label: 'Inventory Request',
          clickHandler: () => {
            window.open(
              `${baseURL}api/v2/print/dispatch/stock-out/${token}/${dispatchID}`,
            )
          },
        },
      ],
    },
    {
      label: 'Export',
      children: [
        {
          label: 'Dispatch Order',
          clickHandler: () => {
            exportReport()
          },
        },
        {
          label: 'Inventory Request',
          disabled: isDaraz(),
          clickHandler: () => {
            window.open(
              `${baseURL}api/v2/export/dispatch/stock-out/${token}/${dispatchID}`,
            )
          },
        },
      ],
    },
  ]

  const handleRowChange = (row) => {
    const allIDs = row?.selectedRows?.map((item) => {
      return item.order_id
    })
    setBulkDispatchIds({
      order_ids: allIDs,
    })
    setSelectedOrders(row.selectedRows)
    setBulkButtonAble(row.selectedCount)
  }

  const checker = () => {
    const rows = selectedOrders
    const value = rows?.map((item: IOrders) => {
      if (item.is_packed) {
        return false
      }
      return true
    })
    const check = value?.includes(true)
    return check
  }

  const scanningOrder = (trackingId: string) => {
    showPageLoader()
    post(`/dispatch/${dispatchID}/bulk/scanning-done`, {
      tracking_id: trackingId,
    }).subscribe((res: any) => {
      hidePageLoader()
      setScannedTrackingId('')
      if (res.response.data) {
        showSuccess('Package Scan Successfully')
        const headerDetail = res.response.data.header
        setDispatchDetail(headerDetail)
        const tableData = res.response.data.details?.sort((a, b) => {
          return b.is_packed - a.is_packed
        })
        setDispatchTableData(tableData)
      } else {
        showFailure(res.response.error)
      }
    })
  }

  const handleScannerScan = (trackingId: string) => {
    const existingOrder = dispatchTableData.find(
      (order: any) => order.tracking_id === trackingId,
    )

    if (existingOrder) {
      showPageLoader()
      setShowScanner(false)
      post(`/dispatch/${dispatchID}/bulk/packing-done`, {
        order_ids: [existingOrder.order_id],
      }).subscribe((res: any) => {
        hidePageLoader()
        if (res.response.data) {
          showSuccess(`Order ${trackingId} marked as packed successfully!`)
          const updatedTableData = dispatchTableData.map((order: any) => {
            if (order.tracking_id === trackingId) {
              return { ...order, is_packed: true }
            }
            return order
          })
          setDispatchTableData(updatedTableData)
          readData(isPacked)
          const headerDetail = res.response.data.header
          setDispatchDetail({
            ...headerDetail,
            cod: headerDetail?.total_cod_amount?.toString() || '0',
            packages: headerDetail?.total_packages || 0,
            processing_time_stats: headerDetail?.processing_time_stats || {
              green: 0,
              yellow: 0,
              red: 0,
            },
          })

          setScannedTrackingId('')
          handleCloseItemDetails()
          setShowScanner(true)
        } else {
          showFailure(res.response.error || 'Failed to mark order as packed')
        }
      })
    } else {
      // If order not found, show message
      showFailure(`No order found with tracking ID: ${trackingId}`)
      setScannedTrackingId('')
    }
  }

  const handleManualTrackingIdInput = (trackingId: string) => {
    if (!trackingId.trim()) return

    // Check if the tracking ID exists in current dispatch data
    const existingOrder = dispatchTableData.find(
      (order: any) => order.tracking_id === trackingId.trim(),
    )

    if (existingOrder) {
      // If order exists, open its details immediately
      setSelectedItem(existingOrder)
      showSuccess(`Order details opened for tracking ID: ${trackingId}`)
      setScannedTrackingId('')
      // Re-focus the input for next scan
      if (trackingInputRef.current) {
        trackingInputRef.current.focus()
      }
    } else {
      // If order not found, show message
      showFailure(`No order found with tracking ID: ${trackingId}`)
      setScannedTrackingId('')
      // Re-focus the input for next scan
      if (trackingInputRef.current) {
        trackingInputRef.current.focus()
      }
    }
  }

  const handleTrackingIdChange = (value: string) => {
    setScannedTrackingId(value)
    setIsScanning(true)

    if (scanTimeoutRef.current) {
      clearTimeout(scanTimeoutRef.current)
    }

    scanTimeoutRef.current = setTimeout(() => {
      if (value.trim()) {
        handleManualTrackingIdInput(value)
      }
      setIsScanning(false)
    }, 150)
  }
  const printLabel = () => {
    let orders_data: object[] = []
    orders_data = selectedOrders?.map((item) => {
      return {
        eoct_id: item.eoct_id,
        order_id: item.order_id,
        note_print_on_label: item.print_customer_note_on_shipping_label,
        courier_logo: dispatchDetail?.courier_logo,
        courier_company: dispatchDetail?.courier_name,
      }
    })
    showPageLoader()
    printShippingLabels({
      dispatch_id: dispatchID,
      orders_data,
    }).subscribe((res: any) => {
      if (res.response) {
        downLoadFile(res.response, 'ShippingLabels.pdf', 'application/pdf')
        hidePageLoader()
      } else {
        hidePageLoader()
        showFailure('Something went wrong')
      }
    })
  }
  const handleCloseItemDetails = () => {
    setSelectedItem(null)
    if (trackingInputRef.current) {
      trackingInputRef.current.focus()
    }
  }
  return (
    <DcFlexBox flexDirection="column">
      <DcFlexBox
        padding="0px 20px"
        height="60px"
        style={{
          justifyContent: 'space-between',
          borderBottom: `1px solid ${colors.grayBorderLight}`,
        }}
        alignItems="center"
      >
        <DcFlexBox alignItems="center" width="auto">
          <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />
          <SectionActions />
        </DcFlexBox>
        <DcDiv>
          <ProfileSection />
        </DcDiv>
      </DcFlexBox>

      <PixelPageContainer
        overflow="hidden"
        height="calc(100vh-110px)"
        padding="0px"
      >
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px 20px' }}>
            <DcFlexBox
              padding="5px 0px"
              height="auto"
              justifyContent="flex-end"
              alignItems="center"
            >
              {isMobile ? (
                <DcFlexBox position="relative" height="auto" gap="5px">
                  <DcInput
                    showsearchicon={0}
                    placeholder="Search"
                    name="search"
                    onChange={(e) => setFilterText(e.target.value)}
                    value={filterText}
                  />
                  <DcDiv position="absolute" right="0px" top="2px">
                    <DcButton
                      variant="link"
                      onClick={() => setShowActions(true)}
                    >
                      <FilterLinesIcon size={16} />
                    </DcButton>{' '}
                  </DcDiv>
                </DcFlexBox>
              ) : (
                <DcFlexBox
                  width="100%"
                  height="auto"
                  justifyContent="space-between"
                  flexDirection={isMobile ? 'column' : 'row'}
                  gap={isMobile ? '5px' : '0px'}
                >
                  <DcFlexBox
                    height="auto"
                    width={isMobile ? '100%' : '20%'}
                    gap="5px"
                  >
                    <DcInput
                      inputSize="small"
                      showsearchicon={0}
                      placeholder="Search"
                      name="search"
                      onChange={(e) => setFilterText(e.target.value)}
                      value={filterText}
                    />{' '}
                    <DcDropDown
                      dropdownSize="sm"
                      placeholder="Select Type"
                      options={[
                        {
                          label: 'All Orders',
                          value: 'null',
                        },
                        {
                          label: 'Packed',
                          value: 1,
                        },
                        {
                          label: 'Unpacked',
                          value: 0,
                        },
                      ]}
                      value={isPacked}
                      onChange={(e) => {
                        setIsPacked(e.target.value)
                      }}
                    />
                  </DcFlexBox>
                  <DcFlexBox
                    justifyContent="flex-end"
                    height="auto"
                    width={isMobile ? '100%' : '80%'}
                    gap="5px"
                  >
                    <DcTag
                      textColor={
                        dispatchDetail.dispatch_status === 'ready-to-ship '
                          ? colors.secondary
                          : dispatchDetail.dispatch_status === 'shipped'
                          ? colors.danger
                          : dispatchDetail.dispatch_status === 'packaging'
                          ? colors.primary
                          : dispatchDetail.dispatch_status === 'open'
                          ? colors.warning
                          : colors.info
                      }
                      customBackgroundColor={
                        dispatchDetail.dispatch_status === 'ready-to-ship '
                          ? colors.secondaryLight
                          : dispatchDetail.dispatch_status === 'shipped'
                          ? colors.dangerLight
                          : dispatchDetail.dispatch_status === 'packaging'
                          ? colors.primaryLight
                          : dispatchDetail.dispatch_status === 'open'
                          ? colors.warningLight
                          : colors.infoLight
                      }
                    >
                      {dispatchDetail.dispatch_status}
                    </DcTag>

                    <PixelDropDownMenu
                      // disabled={!details?.is_editable}
                      size="sm"
                      variant="outline"
                      color={$DCprimaryColor}
                      isGrouped
                      options={PrintSheetsOptions.map((status) => {
                        return {
                          ...status,
                          label: status?.label,
                          formatter: (option, i) => {
                            return (
                              <DcFlexBox
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  alignContent: 'center',
                                  width: '100%',
                                  height: 'auto',
                                }}
                                key={i}
                              >
                                {option.label}
                              </DcFlexBox>
                            )
                          },
                          children: status?.children?.map((child) => {
                            return {
                              ...child,
                              label: child.label,
                              disabled: child.disabled ? isDaraz() : false,
                              formatter: (option) => {
                                return (
                                  <>
                                    {option ? (
                                      <DcFlexBox
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          justifyContent: 'space-between',
                                          alignItems: 'center',
                                          alignContent: 'center',
                                          width: '100%',
                                          height: 'auto',
                                        }}
                                      >
                                        <PixelText
                                          style={{
                                            fontSize: '12px',
                                            fontWeight: '400',
                                            color: ' rgba(0, 0, 0, 0.84)',
                                          }}
                                        >
                                          {option.label}
                                        </PixelText>
                                      </DcFlexBox>
                                    ) : (
                                      'Not available'
                                    )}
                                  </>
                                )
                              },
                              clickHandler: () => {
                                child.clickHandler()
                              },
                            }
                          }),
                        }
                      })}
                      toggleText={'Actions'}
                    />
                    <DcButton
                      size="sm"
                      variant="outline-secondary"
                      onClick={() => setShowUploadModal(true)}
                      withIcon={true}
                    >
                      <UploadIcon size={16} />
                      <span>Upload</span>
                    </DcButton>

                    {dispatchAttachment.attachment_id !== '' && (
                      <DcButton size="sm">
                        <a
                          href={dispatchAttachment.attachment_path}
                          download={dispatchAttachment.attachment_name}
                        >
                          Download
                        </a>
                      </DcButton>
                    )}
                    {dispatchDetail?.dispatch_status === '' ? (
                      <Col style={{ width: '70%' }}></Col>
                    ) : (
                      <>
                        {bulkButtonAble > 0 ? (
                          <div style={{ display: 'flex' }}>
                            <DcButton
                              variant={'outline-secondary'}
                              size="sm"
                              disabled={!checker()}
                              onClick={() => {
                                bulkActions('packing-done')
                              }}
                            >
                              Pack Items
                            </DcButton>
                            <DcButton
                              variant={'outline-secondary'}
                              size="sm"
                              onClick={() => {
                                bulkActions('remove-items')
                              }}
                            >
                              Remove Items
                            </DcButton>
                            <DcButton
                              variant={'outline-secondary'}
                              size="sm"
                              onClick={() => {
                                printLabel()
                              }}
                            >
                              Print Shipping Labels(New)
                            </DcButton>
                          </div>
                        ) : (
                          <>
                            <AlertContainer>
                              <DcButton
                                variant={'outline-secondary'}
                                size="sm"
                                onClick={() => {
                                  setShowScanner(true)
                                }}
                                withIcon={true}
                              >
                                <ScanIcon size={16} />
                                <span>Scan Orders</span>
                              </DcButton>
                            </AlertContainer>
                          </>
                        )}
                      </>
                    )}
                  </DcFlexBox>
                </DcFlexBox>
              )}
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section
          style={{
            padding: '20px',
            height: 'calc(100vh - 110px)',
            overflow: 'auto',
          }}
        >
          <DcFlexBox height="auto">
            <SummaryCard
              dispatchData={{
                dispatchId: dispatchDetail?.dispatch_id?.toString(),
                dispatchDate: dispatchDetail?.created_at,
                warehouse: dispatchDetail?.warehouse_id?.toString(),
                cod: dispatchDetail?.cod,
                packages: dispatchDetail?.packages,
                pieces: dispatchDetail?.total_pieces,
                weight: dispatchDetail?.total_packages_weight?.toString(),
                createdBy: dispatchDetail?.created_by_name,
                date: dispatchDetail?.created_at,
                courier: dispatchDetail?.courier_name,
                status: (['completed', 'pending', 'failed'].includes(
                  dispatchDetail?.dispatch_status,
                )
                  ? dispatchDetail?.dispatch_status
                  : 'pending') as 'completed' | 'pending' | 'failed',
                processing_time_stats: dispatchDetail?.processing_time_stats,
              }}
            />
          </DcFlexBox>
          <DcFlexBox height="auto" padding="20px 0px 0px 0px">
            <SectionContent
              style={{
                padding: '10px',
                height: 'calc(100vh - 410px)',
                overflow: 'auto',
              }}
            >
              <>
                <AlertContainer>
                  <DcFlexBox
                    width={isMobile ? 'auto' : '350px'}
                    height="auto"
                    padding="10px 0px 10px 0px"
                    style={{
                      flexDirection: 'column',
                      gap: '8px',
                    }}
                  >
                    <DcFlexBox
                      justifyContent="space-between"
                      alignItems="center"
                      style={{ width: '100%' }}
                    >
                      <DcText
                        style={{
                          fontSize: '14px',
                          fontWeight: '600',
                          color: colors.grayTextMedium,
                        }}
                      >
                        📦 Packing Progress
                      </DcText>
                      <DcText
                        style={{
                          fontSize: '12px',
                          color: colors.grayTextMedium,
                        }}
                      >
                        {
                          dispatchTableData.filter(
                            (order: any) => order.is_packed,
                          ).length
                        }{' '}
                        of {dispatchTableData.length} orders packed
                      </DcText>
                    </DcFlexBox>
                    <DcFlexBox
                      style={{
                        width: '100%',
                        height: '12px',
                        backgroundColor: colors.grayLighter,
                        borderRadius: '6px',
                        overflow: 'hidden',
                        position: 'relative',
                      }}
                    >
                      <DcFlexBox
                        style={{
                          width: `${
                            dispatchTableData.length > 0
                              ? (dispatchTableData.filter(
                                  (order: any) => order.is_packed,
                                ).length /
                                  dispatchTableData.length) *
                                100
                              : 0
                          }%`,
                          height: '100%',
                          background: colors.success,
                          borderRadius: '6px',
                          transition: 'width 0.5s ease-in-out',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                      />
                    </DcFlexBox>
                  </DcFlexBox>
                  <DcFlexBox
                    width="auto"
                    height="auto"
                    alignItems="center"
                    gap="5px"
                  >
                    <DcFlexBox
                      height="auto"
                      flexDirection="row"
                      gap="10px"
                      width="260px"
                    >
                      <DcInput
                        inputSize="small"
                        placeholder="Enter Tracking ID to open order details"
                        value={scannedTrackingId}
                        onChange={(e) => {
                          handleTrackingIdChange(e.target.value)
                          setTimeout(() => {
                            if (e.target.value.trim()) {
                              handleManualTrackingIdInput(e.target.value)
                            }
                          }, 300)
                        }}
                        onFocus={() => {
                          // Clear any previous error messages when input gets focus
                          if (scannedTrackingId.trim()) {
                            setScannedTrackingId('')
                          }
                        }}
                        style={{
                          width: '200px',
                          borderColor: isScanning ? colors.primary : undefined,
                          boxShadow: isScanning
                            ? `0 0 0 2px ${colors.primaryLight}`
                            : undefined,
                          transition: 'all 0.2s ease',
                        }}
                        ref={trackingInputRef}
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                        name={''}
                      />
                      {isScanning && (
                        <PixelText
                          textSize="10px"
                          style={{
                            color: colors.primary,
                            fontStyle: 'italic',
                            textAlign: 'center',
                          }}
                        >
                          Scanning...
                        </PixelText>
                      )}
                    </DcFlexBox>
                    <DcButton
                      variant={'outline-secondary'}
                      size="sm"
                      onClick={() => {
                        setShowScanner(true)
                      }}
                      withIcon={true}
                    >
                      <ScanIcon size={16} />
                      <span>Scan Orders</span>
                    </DcButton>
                  </DcFlexBox>
                </AlertContainer>
              </>
              <DispatchDetailsTable
                data={dispatchTableData}
                loading={tableLoading}
                onSelectedRowsChange={handleRowChange}
                clearSelectedRows={toggleCleared}
                isSelectable={dispatchDetail?.dispatch_status === 'open'}
                filterText={filterText}
                onRowClick={(row) => {
                  setSelectedItem(row)
                }}
              />
            </SectionContent>
          </DcFlexBox>
        </Section>
      </PixelPageContainer>

      <DcOverlaySlider
        width="40%"
        title={'Dispatch Details'}
        isOpen={selectedItem !== null}
        onClose={() => setSelectedItem(null)}
      >
        {dispatchID && selectedItem && (
          <DispatchItemDetails
            dispatchId={Number(dispatchID)}
            item={selectedItem}
            onClose={onDispatchItemDetailsClose}
          />
        )}
      </DcOverlaySlider>

      <DcOverlaySlider
        width="40%"
        title={'Upload Dispatch from file'}
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
      >
        {showUploadModal && (
          <SectionContent>
            <UploadDispatch
              handleClose={(data?) => {
                if (data === 'success') {
                  readData(isPacked)
                }
                setShowUploadModal(false)
              }}
              dispatchID={dispatchID}
            />
          </SectionContent>
        )}
      </DcOverlaySlider>
      <DcOverlaySlider
        customWith="50%"
        title={'Actions'}
        isOpen={showActions}
        onClose={() => setShowActions(false)}
        padding="5px"
      >
        {isMobile && (
          <DcFlexBox
            width="100%"
            height="auto"
            justifyContent="space-between"
            flexDirection={'column'}
            gap={isMobile ? '5px' : '0px'}
          >
            <DcFlexBox
              height="auto"
              flexDirection="column"
              width={isMobile ? '100%' : '20%'}
              gap="5px"
            >
              <DcDropDown
                dropdownSize="sm"
                placeholder="Select Type"
                options={[
                  {
                    label: 'All Orders',
                    value: 'null',
                  },
                  {
                    label: 'Packed',
                    value: 1,
                  },
                  {
                    label: 'Unpacked',
                    value: 0,
                  },
                ]}
                value={isPacked}
                onChange={(e) => {
                  setIsPacked(e.target.value)
                }}
              />
            </DcFlexBox>
            <DcFlexBox
              flexDirection="column"
              justifyContent="flex-end"
              height="auto"
              width={isMobile ? '100%' : '80%'}
              gap="5px"
            >
              <DcTag
                textColor={
                  dispatchDetail.dispatch_status === 'ready-to-ship '
                    ? colors.secondary
                    : dispatchDetail.dispatch_status === 'shipped'
                    ? colors.danger
                    : dispatchDetail.dispatch_status === 'packaging'
                    ? colors.primary
                    : dispatchDetail.dispatch_status === 'open'
                    ? colors.warning
                    : colors.info
                }
                customBackgroundColor={
                  dispatchDetail.dispatch_status === 'ready-to-ship '
                    ? colors.secondaryLight
                    : dispatchDetail.dispatch_status === 'shipped'
                    ? colors.dangerLight
                    : dispatchDetail.dispatch_status === 'packaging'
                    ? colors.primaryLight
                    : dispatchDetail.dispatch_status === 'open'
                    ? colors.warningLight
                    : colors.infoLight
                }
              >
                {dispatchDetail.dispatch_status}
              </DcTag>

              <PixelDropDownMenu
                // disabled={!details?.is_editable}
                size="sm"
                variant="outline"
                color={$DCprimaryColor}
                isGrouped
                options={PrintSheetsOptions.map((status) => {
                  return {
                    ...status,
                    label: status?.label,
                    formatter: (option, i) => {
                      return (
                        <DcFlexBox
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            alignContent: 'center',
                            width: '100%',
                            height: 'auto',
                          }}
                          key={i}
                        >
                          {option.label}
                        </DcFlexBox>
                      )
                    },
                    children: status?.children?.map((child) => {
                      return {
                        ...child,
                        label: child.label,
                        disabled: child.disabled ? isDaraz() : false,
                        formatter: (option) => {
                          return (
                            <>
                              {option ? (
                                <DcFlexBox
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    alignContent: 'center',
                                    width: '100%',
                                    height: 'auto',
                                  }}
                                >
                                  <PixelText
                                    style={{
                                      fontSize: '12px',
                                      fontWeight: '400',
                                      color: ' rgba(0, 0, 0, 0.84)',
                                    }}
                                  >
                                    {option.label}
                                  </PixelText>
                                </DcFlexBox>
                              ) : (
                                'Not available'
                              )}
                            </>
                          )
                        },
                        clickHandler: () => {
                          child.clickHandler()
                        },
                      }
                    }),
                  }
                })}
                toggleText={'Actions'}
              />
              <DcButton
                size="sm"
                variant="outline-secondary"
                onClick={() => setShowUploadModal(true)}
                withIcon={true}
              >
                <UploadIcon size={16} />
                <span>Upload</span>
              </DcButton>

              {dispatchAttachment.attachment_id !== '' && (
                <DcButton size="sm">
                  <a
                    href={dispatchAttachment.attachment_path}
                    download={dispatchAttachment.attachment_name}
                  >
                    Download
                  </a>
                </DcButton>
              )}
              {dispatchDetail?.dispatch_status === '' ? (
                <Col style={{ width: '70%' }}></Col>
              ) : (
                <>
                  {bulkButtonAble > 0 ? (
                    <div style={{ display: 'flex' }}>
                      <DcButton
                        variant={'outline-secondary'}
                        size="sm"
                        disabled={!checker()}
                        onClick={() => {
                          bulkActions('packing-done')
                        }}
                      >
                        Pack Items
                      </DcButton>
                      <DcButton
                        variant={'outline-secondary'}
                        size="sm"
                        onClick={() => {
                          bulkActions('remove-items')
                        }}
                      >
                        Remove Items
                      </DcButton>
                      <DcButton
                        variant={'outline-secondary'}
                        size="sm"
                        onClick={() => {
                          printLabel()
                        }}
                      >
                        Print Shipping Labels(New)
                      </DcButton>
                    </div>
                  ) : (
                    <>
                      <AlertContainer>
                        <DcButton
                          variant={'outline-secondary'}
                          size="sm"
                          onClick={() => {
                            setShowScanner(true)
                          }}
                          withIcon={true}
                        >
                          <ScanIcon size={16} />
                          <span>Scan Orders</span>
                        </DcButton>
                      </AlertContainer>
                    </>
                  )}
                </>
              )}
            </DcFlexBox>
          </DcFlexBox>
        )}
      </DcOverlaySlider>

      {/* Scanner Modal */}
      <DcScanner
        isOpen={showScanner}
        onClose={() => {
          setShowScanner(false)
          setScannedTrackingId('')
        }}
        scannedSKU={scannedTrackingId}
        setScannedSKU={setScannedTrackingId}
        handleScan={handleScannerScan}
        scannerRef={scannerRef}
      />
    </DcFlexBox>
  )
}

const Col = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-self: flex-end;
  flex-direction: row;
  gap: 10px;
  transition: height 1s linear;
`

const AlertContainer = styled.div`
  padding: ${isMobile ? '5px 0px' : '0px'};
  display: flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  gap: 10px;
  justify-content: ${isMobile ? 'flex-end' : 'space-between'};
`

export default DispatchDetail
